import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user/user.service';
import { setTimeout } from 'timers';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { Dashboard } from '../../interface/dashboard';
import { CommonService } from '../../services/common/common.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss', './layout.mini.component.scss'],
  host: {
    // '(document:click)': 'outSideClick($event)',
  },
  encapsulation: ViewEncapsulation.None
})
export class LayoutComponent implements OnInit {
  dashboardList: Dashboard[];
  defaultDashboard: string = "";
  currentYear: number;
  hasNotification: boolean = false;
  toggleSideMenu: boolean = true;
  isMobile: boolean = true;
  toggleSideTool: boolean = false;
  toggleDashboard: boolean = false;
  toggleNotification: boolean = false;
  toggleMessages: boolean = false;
  isAuthenticated: boolean = false;
  togglescheduler: boolean = false;
  name: string = "";
  image: string = "";

  constructor(private userService: UserService, private router: Router, private dashboardService: DashboardService, private commonService: CommonService) {
    this.isAuthenticated = this.userService.isAuthenticated();
    this.setData();
    this.setDashboardList();
    this.dashboardService.getAction().subscribe(data => {
      if (["updateName", "deleteDashboard"].includes(data.action)) {
        // console.log(data);
        this.setDashboardList();
      }
    });
  }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();

    this.userService.userDetailsUpdated().subscribe(() => {
      this.setData();
    });

    let that = this;
    $('body').on('click', '.mshadow', function (e) {
      if (!(window.navigator.maxTouchPoints || 'ontouchstart' in window.document.documentElement))
        return;
      e.preventDefault();
      that.toggleSideMenu = !that.toggleSideMenu;
      $('#main-content').removeClass('mshadow');
    });

  }

  contentDivResized = () => {
    setTimeout(() => {
      var resizeEvent = window.document.createEvent('UIEvents');
      resizeEvent.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(resizeEvent);
    }, 100);
    var tmp = this;
    setTimeout(() => {
      tmp.commonService.sendAction("redesignTableComponent", "");
    }, 1000);
  }

  showMenuShadow = () => {
    if (window.navigator.maxTouchPoints || 'ontouchstart' in window.document.documentElement) {
      if (this.toggleSideMenu)
        $('#main-content').addClass('mshadow');
      else
        $('#main-content').removeClass('mshadow');
    }
    else {

    }
  }

  logout = () => {
    let _user = this.userService.getLoggedInUser();
    this.commonService.deleteIdxWidgetDataOnLogout(_user._id);
    this.userService.logout();
  };

  outSideClick(e) {
    if (e.target.className.search('notification') == -1 &&
      e.target.className.search('bell') == -1) {
      this.toggleNotification = false;
    }
    if (e.target.className.search('dropdown-notification') == -1 && e.target.className.search('flaticon-envelope') == -1) {
      this.toggleMessages = false;
    }
  }

  redirectToProfile() {
    this.router.navigate(['/profile']);
  }

  redirectToHome() {
    this.router.navigate(['/dashboard']);
  }

  setData() {
    let userDetails = this.userService.getLoggedInUser();
    this.name = userDetails["name"] ? userDetails["name"] : "";
    this.image = userDetails["profileImage"] ? "https://xpandretail-assets.s3.amazonaws.com/" + userDetails["profileImage"] + "?v=" + (new Date().getTime()) : "assets/img/profile-pic.png";
    this.defaultDashboard = userDetails["defaultDashboard"];
  }

  setDashboardList() {
    if (!this.isAuthenticated) {
      return;
    }

    this.dashboardService.list().subscribe(res => {
      this.dashboardList = res;
    }, (err) => { });
  }

  goOnHomeDashboard() {
    this.userService.redirectToHome(this.router);
  }

}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/layout/layout.component.ts